import { RouteConfig } from 'vue-router'
import lazyImporter from '@/utils/lazyImporter'

const authorRoute: RouteConfig = {
  component: lazyImporter('View'),
  path: '/author',
  meta: { title: 'authors', icon: 'face' },
  name: 'admin_authors',
  redirect: { name: 'admin_author_list' },
  children: [
    {
      component: lazyImporter('author/AuthorList'),
      meta: { title: 'authorList', hidden: true },
      name: 'admin_author_list',
      path: ''
    },
    {
      component: lazyImporter('author/AuthorAdd'),
      meta: { title: 'authorAdd', hidden: true },
      name: 'admin_author_add',
      path: 'add'
    },
    {
      component: lazyImporter('author/AuthorUpdate'),
      meta: { title: 'authorUpdate', hidden: true },
      name: 'admin_author_update',
      path: ':slug/update',
      props: true
    }
  ]
}

export default authorRoute
